import React from 'react';
import { Grid } from 'fw/forms';
import VoteStatus from 'areas/admin/certification/commReview/votes/VoteStatus';
import * as Formatter from 'fw/components/formatter/Formatter';

const columns = [
	{ key: 'userName', name: 'User', sortable: false },
	{ key: 'status', name: 'Vote', width: 250, sortable: false, formatter: VoteStatus },
	{ key: 'castDate', name: 'Date', sortable: false, formatter: Formatter.DateTime}
];

class VotesGrid extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
		return {
			votes: this.props.votes
		};
	}

	render() {
		return (
			<React.Fragment>
				<Grid
					columns={columns}
					items={this.props.votes}
					height={275}
					className="table-condensed"
					rowKey="id"
					name="default" />
				<hr />
				<div className="btn-toolbar">
				</div>
			</React.Fragment>
		)
	}
}

export default VotesGrid;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/commReview/votes/VotesGrid.js